import React, { FC } from "react";
import { faListCheck } from "@fortawesome/pro-regular-svg-icons/faListCheck";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const ListCheck: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faListCheck} {...props} />
);
